import { render, staticRenderFns } from "./36.vue?vue&type=template&id=e037a8e8&"
import script from "./36.vue?vue&type=script&lang=js&"
export * from "./36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports